import { useLocation } from 'react-router-dom'

/**
 * 内容模块的落地前缀（单一事实来源）
 *
 * 同一套页面组件（ContentList / ContentEditor / ContentPhonePreview）同时服务两个入口：
 *   - 管理端：/admin/content/*   —— admin（全量管理）、supervisor/staff（在管理端布局下投稿）
 *   - 医护端：/medical/author/*  —— 医护人员的图文投稿入口（2026-09-20 开放）
 *
 * 组件内部与角色无关的分支（isAdmin）走接口切换，而「跳回列表 / 去新建 / 编辑详情」
 * 这类跳转的路径前缀必须跟随当前入口，否则在医护端会把用户甩到管理端布局里。
 *
 * 判断方式用「当前 pathname 前缀」而不是 userType：组件本身不接收 userType，
 * 且路由前缀已经是用户所处空间的准确描述。
 */
export const ADMIN_CONTENT_BASE = '/admin/content'
export const MEDICAL_AUTHOR_BASE = '/medical/author'

/** 当前所处的内容模块前缀：医护端返回 /medical/author，其余（管理端）返回 /admin/content */
export function useContentBasePath(): string {
  const { pathname } = useLocation()
  return pathname.startsWith('/medical') ? MEDICAL_AUTHOR_BASE : ADMIN_CONTENT_BASE
}
